import { Component, computed, ViewChild, ElementRef, Output, EventEmitter, NgZone, effect, OnChanges, SimpleChanges, Input, signal, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { GenericValidationService } from '@app/common-codes/services/GenericValidationService';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { ActivatedRoute, Router } from '@angular/router';
import { OnReadyDirective } from '@app/common-codes/components/directives/OnReadyDirective';
import { FieldContextDirective } from '@app/common-codes/components/directives/FieldContext.directive';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { Dock } from '@app/common-codes/models/matwins-tenant/Dock.model';
import { LookupItem } from '@app/common-codes/services/LookupService';
import { ReactiveBadgeComponent } from '@app/common-codes/components/nested-components/reactive-badge/reactive-badge.component';
import { MultiSelectComponent } from '@app/common-codes/components/nested-components/multi-select/multi-select.component';
import { FieldWrapperComponent } from '@app/common-codes/components/nested-components/field-wrapper/field-wrapper.component';


@Register(Dock)
@Component({
  selector: 'app-dock-detail',
  templateUrl: './dock-detail.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, TranslatePipe, OnReadyDirective, ReactiveBadgeComponent, MultiSelectComponent, FieldWrapperComponent, FieldContextDirective]
})
export class DockDetailComponent extends GenetricDetailComponent<Dock> implements OnChanges {
  override ComponentEntityClass = Dock;
  @Input() fkPointOfServiceId: number | null = null;
  Skin = MatwinsSkins.V1 as IStaticStylesConfig;
  @Output() itemSaved = new EventEmitter<Dock>();
  dockStatusLookup = signal<LookupItem[]>([]);
  pointOfServiceLookup = signal<LookupItem[]>([]);


  onStatusChange(newStatus: number): void {
    const currentEntity = this.editingEntity();
    if (currentEntity) {
      const newEntity = Object.assign(new Dock(), currentEntity);
      newEntity.status = newStatus;
      this.editingEntity.set(newEntity);
    }
  }

  constructor(
    route: ActivatedRoute,
    router: Router,
    translationService: TranslationService,
    validationService: GenericValidationService,
    alertModalService: AlertModalService,
    ngZone: NgZone
  ) {
    super(route, router, translationService, validationService, ngZone);
    this.alertModalService = alertModalService;
    effect(() => {
      const entity = this.editingEntity();
      if (entity) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.dockStatusLookup.set(this.lookupService.getLookupData('DockStatus'));
        this.pointOfServiceLookup.set(this.lookupService.getLookupData('PointOfService'));
        this.loadPos();
      }
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  loadPos() {
    const entity = this.editingEntity();
    if (!entity) {
      return;
    }
    const selected = entity.fK_PointOfService;
    if (!selected) {
      return;
    }
    entity.selectedPK_Pos = [selected.toString()];
  }

  onPOSselectChange(evt: string[]) {
    const dock = this.editingEntity();
    if (!dock) {
      return;
    }

    const selectedPosIds = (evt ?? [])
      .map(k => Number(k))
      .filter(n => Number.isFinite(n));

    dock.fK_PointOfService = selectedPosIds[0] ?? null;
    dock.selectedPK_Pos = evt;

  }

  override getEmptyEntity(): Dock {
    const dock = new Dock();
    dock.status = 1; // Available
    if (this.fkPointOfServiceId) {
      dock.fK_PointOfService = this.fkPointOfServiceId;
    }
    else if (this.matwinsVariablesService.posId) {
      dock.fK_PointOfService = this.matwinsVariablesService.posId;
    }
    return dock;
  }

  override parseToEntityInstance(): void {
    if (this.EntityInstance && this.editingEntity()) {
      Object.assign(this.EntityInstance, this.editingEntity());
    }
  }

  async saveItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
    }
  }

  async saveAndCloseItem(): Promise<void> {
    const savedItem = await this.save();
    if (savedItem) {
      this.itemSaved.emit(savedItem);
      this.closeModal.emit();
    }
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    // const entityChange = changes['EntityInstance'];
    // if (entityChange && entityChange.currentValue) {
    //   this.editingEntity.update(entity => {
    //     if (entity) {
    //       entity.status = entityChange.currentValue.status;
    //     }
    //     return entity;
    //   });
    // }
  }
}

